import { Alert, App, Button, Input, Modal, Table } from 'antd';
import { useState } from 'react';
import { pasteIntoTable } from '../api';
import { AdminTable, PasteSeatResult, errorText } from '../contract';
import styles from '../styles.module.scss';

const { TextArea } = Input;

interface Props {
  eventId: number;
  /** null = đóng. */
  table: AdminTable | null;
  onClose: () => void;
  /** Gọi sau khi xếp xong (nạp lại sơ đồ); modal vẫn mở để xem kết quả. */
  onDone: () => void | Promise<void>;
}

/** Dán danh sách (mỗi dòng một tên hoặc UID TikTok) vào các ghế trống của một bàn (SPEC mục 4, 7). */
const TablePasteModal = ({ eventId, table, onClose, onDone }: Props) => {
  const { message } = App.useApp();
  const [text, setText] = useState('');
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState<PasteSeatResult | null>(null);

  const submit = async () => {
    if (!table || !text.trim()) return;
    setSaving(true);
    try {
      const res = await pasteIntoTable(eventId, table.id, text);
      setResult(res);
      setText('');
      await onDone();
    } catch (e) {
      message.error(errorText(e, 'Không xếp được danh sách.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title={table ? `Dán danh sách — ${table.name}` : 'Dán danh sách'}
      open={!!table}
      onCancel={onClose}
      destroyOnHidden
      afterOpenChange={(open) => {
        if (!open) {
          setText('');
          setResult(null);
        }
      }}
      footer={[
        <Button key="close" onClick={onClose}>
          Đóng
        </Button>,
        <Button key="go" type="primary" loading={saving} disabled={!text.trim()} onClick={submit}>
          Xếp
        </Button>,
      ]}
    >
      <p className={styles.hint}>
        Khớp vé theo UID TikTok; UID không có vé hoặc vé đã thu hồi sẽ bị bỏ qua kèm lý do. Dòng
        không có UID thì khớp theo tên trên vé (duy nhất trong sự kiện); không khớp thì ghi thành
        tên tay. Điền lần lượt vào ghế trống theo số tăng dần.
      </p>
      <TextArea
        rows={10}
        value={text}
        autoFocus
        onChange={(e) => setText(e.target.value)}
        placeholder="Mỗi dòng một tên hoặc UID TikTok"
        style={{ marginTop: 8 }}
      />
      {result && (
        <div className={styles.seatPasteResult}>
          <Alert
            type={result.skipped.length ? 'warning' : 'success'}
            showIcon
            message={`Đã xếp ${result.assigned}, tên tay ${result.manual}, bỏ qua ${result.skipped.length}`}
          />
          {result.skipped.length > 0 && (
            <Table
              size="small"
              rowKey="line"
              pagination={false}
              scroll={{ y: 200 }}
              dataSource={result.skipped}
              columns={[
                { title: 'Dòng', dataIndex: 'line', width: 70 },
                { title: 'Lý do', dataIndex: 'reason' },
              ]}
            />
          )}
        </div>
      )}
    </Modal>
  );
};

export default TablePasteModal;
